import { useMyPoints } from '../../points';
import { selectCartTotal, useCart } from '../cart-store';

/**
 * Live points balance minus everything already in the cart — the budget left to spend.
 * Single source for both the per-item affordability gate (`useCanAfford`) and the
 * market-wide "Available" filter, so the list and the Add-to-cart buttons always agree.
 */
export const useRemainingBudget = () => {
  const { data } = useMyPoints();
  const balance = data?.balance ?? 0;
  const cartTotal = useCart(selectCartTotal);
  return { balance, remaining: balance - cartTotal };
};
